import PropTypes from "prop-types";
import { useMediaQueryContext } from "lib/mediaQueryContext";
import Hero from "./hero/Hero";
import Categories from "./categories/Categories";
import Faq from "./faq/Faq";

const TOP_THREE_QUESTIONS = "Top 3 vragen";

export default function Helpdesk({ categoriesFaq }) {
    const { mobileView, desktopView } = useMediaQueryContext();
    const categories = categoriesFaq.filter(category => category.name);
    const topThreeQuestions = categoriesFaq?.find(
        category => category.name === TOP_THREE_QUESTIONS
    );
    const mainCategories = categories?.filter(
        category => category.name !== TOP_THREE_QUESTIONS
    );

    return (
        <>
            <Hero />

            {mobileView && mainCategories && (
                <Categories type="mobile" categoriesList={mainCategories} />
            )}

            {topThreeQuestions && <Faq faq={topThreeQuestions} />}

            {desktopView && mainCategories && (
                <Categories categoriesFaq={mainCategories} />
            )}
        </>
    );
}

Helpdesk.propTypes = {
    categoriesFaq: PropTypes.arrayOf(PropTypes.object).isRequired
};
